/** Axis and grid lines use the coval neutral border token (theme-aware). */
export const DIVIDER_STROKE = "var(--coval-border)"

/**
 * Axis ticks and axis names. Muted so the plotted data stays the loudest thing
 * on the card, and theme-aware so they stay legible on a dark background —
 * recharts otherwise defaults both to a fixed grey.
 */
export const AXIS_TEXT_FILL = "var(--coval-text-muted)"

/**
 * The crosshair a chart draws under the pointer. A step stronger than
 * DIVIDER_STROKE so it reads as the pointer rather than as another gridline.
 */
export const HOVER_CURSOR_STROKE = "var(--coval-border-active)"

/**
 * The band a category chart fills behind the hovered column or row. Keyed to the
 * text color, so it darkens a light card and lightens a dark one. The opacity is
 * a separate attribute rather than an alpha baked into the color, because a
 * presentation attribute like `fill` resolves `var()` but not `color-mix()`.
 */
export const HOVER_CURSOR_FILL = "var(--coval-text)"
export const HOVER_CURSOR_FILL_OPACITY = 0.1

/**
 * The ring around a hovered data point. It reads as the card cut away from
 * behind the dot, so it is the card's own surface rather than a fixed white —
 * which on a dark card was a halo brighter than anything else on it.
 */
export const ACTIVE_DOT_RING_STROKE = "var(--surface-default)"
